import React, { useState, useEffect } from "react";
import { TextField, InputAdornment, IconButton } from "@mui/material";
import { useFormik } from "formik";
import * as yup from "yup";
import CryptoJS from "crypto-js";

import { login, verifyEmail } from "../../Actions/AuthActions";
import { CRYPTO_TOKEN_SECRET_KEY } from "../../config";
import { MyVisibilityIcon, MyVisibilityOffIcon } from "../../Assets/svg/MyIcons";
import { FRONTEND_MESSAGES } from "../../utils/messages";

const { VALIDATION } = FRONTEND_MESSAGES;

const cleanEmail = (value) => {
	return value
		.replace(/[\u200B-\u200D\uFEFF]/g, "")
		.replace(/\s+/g, "")
		.trim();
};

const encryptData = (data) => {
	return CryptoJS.AES.encrypt(
		typeof data === "string" ? data : JSON.stringify(data),
		CRYPTO_TOKEN_SECRET_KEY
	).toString();
};

const LoadingSpinner = () => (
	<span className="spinner-border spinner-border-sm ms-2" role="status" aria-hidden="true" />
);

const emailValidationSchema = yup.object().shape({
	email: yup
		.string()
		.trim()
		.required(VALIDATION.REQUIRED_FIELD("Email"))
		.min(1, VALIDATION.MIN_LENGTH("Email", 1))
		.max(70, VALIDATION.MAX_LENGTH("Email", 70))
		.email(VALIDATION.INVALID_EMAIL)
		.matches(
			/^[a-zA-Z0-9.@_\-]+$/,
			VALIDATION.INVALID_EMAIL
		),
});

const loginValidationSchema = yup.object().shape({
	email: yup
		.string()
		.trim()
		.required(VALIDATION.REQUIRED_FIELD("Email"))
		.min(1, VALIDATION.MIN_LENGTH("Email", 1))
		.max(70, VALIDATION.MAX_LENGTH("Email", 70))
		.email(VALIDATION.INVALID_EMAIL)
		.matches(
			/^[a-zA-Z0-9.@_\-]+$/,
			VALIDATION.INVALID_EMAIL
		),
	password: yup
		.string()
		.required(VALIDATION.REQUIRED_FIELD("Password"))
		.min(8, VALIDATION.MIN_LENGTH("Password", 8))
		.max(20, VALIDATION.MAX_LENGTH("Password", 20))
		.matches(
			/^[A-Za-z0-9!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]+$/,
			VALIDATION.PASSWORD_WEAK
		),
});

const Login = ({
	email,
	setEmail,
	setAccessToken,
	ip,
	setUserDetails,
	showSnackbar,
	browser,
	navigate,
	updateUserData,
	setCurrentScreen,
	SCREENS,
	isEmailVerified,
	setIsEmailVerified,
	setIsIpBlocked
}) => {
	// const getInitialEmailState = () => {
	// 	const rememberedEmail = localStorage.getItem("rememberedEmail");
	// 	const rememberExpiry = localStorage.getItem("rememberExpiry");

	// 	if (rememberedEmail && rememberExpiry) {
	// 		const expiryTime = parseInt(rememberExpiry);
	// 		const currentTime = new Date().getTime();

	// 		if (currentTime < expiryTime) {
	// 			return {
	// 				email: rememberedEmail,
	// 				isVerified: true,
	// 				rememberMe: true
	// 			};
	// 		} else {
	// 			localStorage.removeItem("rememberedEmail");
	// 			localStorage.removeItem("rememberExpiry");
	// 		}
	// 	}

	// 	return {
	// 		email: email || "",
	// 		// isVerified: isEmailVerified,
	// 		isVerified: true,
	// 		rememberMe: false
	// 	};
	// };

	// const initialEmailState = getInitialEmailState();

	// const [verifyEmailScreen, setVerifyEmailScreen] = useState(!initialEmailState.isVerified && !isEmailVerified);
	const [verifyEmailScreen, setVerifyEmailScreen] = useState(true);
	const [loading, setLoading] = useState(false);
	const [buttonDisable, setButtonDisable] = useState(false);
	const [showLoginPassword, setShowLoginPassword] = useState(false);
	// const [rememberMe, setRememberMe] = useState(initialEmailState.rememberMe);

	// useEffect(() => {
	// 	if (initialEmailState.isVerified && initialEmailState.email) {
	// 		setEmail(initialEmailState.email);
	// 		setIsEmailVerified(true);
	// 	}
	// }, []);

	useEffect(() => {
		setVerifyEmailScreen(!isEmailVerified);

		if (isEmailVerified && email) {
			formikLogin.setFieldValue("email", email);
		}
	}, [isEmailVerified, email]);

	const formikLogin = useFormik({
		initialValues: {
			email:  "",
			password: "",
			ip,
		},
		validationSchema: verifyEmailScreen ? emailValidationSchema : loginValidationSchema,
		onSubmit: handleLogin,
		enableReinitialize: true,
	});

	// const handleRememberMe = () => {
	// 	if (rememberMe) {
	// 		const expiryTime = new Date().getTime() + 24 * 60 * 60 * 1000; // 24 hours
	// 		localStorage.setItem("rememberedEmail", formikLogin.values.email);
	// 		localStorage.setItem("rememberExpiry", expiryTime.toString());
	// 	} else {
	// 		localStorage.removeItem("rememberedEmail");
	// 		localStorage.removeItem("rememberExpiry");
	// 	}
	// };

	const handleSuccessfulLogin = (checkUser) => {
		// console.log("checkUsercheckUsercheckUsercheckUsercheckUsercheckUsercheckUsercheckUser", checkUser);
		updateUserData(checkUser);
		localStorage.setItem("userData", encryptData(checkUser));
		localStorage.setItem("GLOBAL_SETTING", encryptData(checkUser?.settingData));

		showSnackbar("Login successful!", "success");

		setTimeout(() => {
			if (!checkUser.isTermsRead) {
				navigate("/T&C");
			} else if (checkUser.isPaasExpiresWarning) {
				localStorage.setItem("passwordExpiry", true);
				localStorage.setItem("passwordExpiryDaysLeft", checkUser.daysLeft);
				navigate("/dashboard");
			} else {
				navigate("/dashboard");
			}
		}, 1000);
	};

	async function handleLogin() {
		// if (formikLogin.values.email && verifyEmailScreen) {
		// 	setButtonDisable(true);
		// 	setLoading(true);

		// 	try {
		// 		const data = { email: formikLogin.values.email, ip };
		// 		const res = await verifyEmail(data);

		// 		if (res.status === 202) {
		// 			showSnackbar(res.data.message, "info");
		// 		} else {
		// 			setUserDetails(res.data);
		// 			setVerifyEmailScreen(false);
		// 			setEmail(formikLogin.values.email);
		// 			setIsEmailVerified(true);

		// 			const firstTimeLogin = res.data?.data?.isFirstTimeLogin;

		// 			if (firstTimeLogin) {
		// 				setCurrentScreen(SCREENS.SET_PASSWORD);
		// 			} else {
		// 				showSnackbar(res.data.message, "success");
		// 			}
		// 		}
		// 	} catch (err) {
		// 		if (err.response?.status === 429) {
		// 			setIsIpBlocked(true);
		// 		}
		// 		showSnackbar(err.response?.data?.message || "Something went wrong!", "error");
		// 	} finally {
		// 		setLoading(false);
		// 		setButtonDisable(false);
		// 	}
		// 	return;
		// }

		if (formikLogin.values.email && formikLogin.values.password) {
			setButtonDisable(true);
			setLoading(true);

			try {
				const data = {
					email: formikLogin.values.email,
					password: formikLogin.values.password,
					ip,
					country: "",
					browserName: browser,
				};

				const res = await login(data);

				if (res?.data?.data?.isPassExpired) {
					setEmail(res?.data?.data?.userEmail);
					setCurrentScreen(SCREENS.CHANGE_PASSWORD);
					showSnackbar(res?.data?.message, "info");
					return;
				}

				if (res?.data?.status === 204) {
					showSnackbar("Invalid username or password", "error");
					return;
				}

				localStorage.setItem("token", encryptData(res.data?.data.token));
				setAccessToken(res.data?.data.token);
				setEmail(formikLogin.values.email);

				// handleRememberMe();

				if (res.data?.data.checkUser.twoFactor) {
					setCurrentScreen(SCREENS.VERIFY_OTP);
				} else {
					handleSuccessfulLogin(res.data?.data.checkUser);
				}
			} catch (err) {
				showSnackbar(err.response?.data?.message || "Something went wrong!", "error");
			} finally {
				setLoading(false);
				setButtonDisable(false);
			}
		}
	}

	const toggleLoginPasswordVisibility = () => setShowLoginPassword((prev) => !prev);

	const getButtonDisabled = () => {
		if (verifyEmailScreen) {
			return buttonDisable || loading || !formikLogin.values.email || !!formikLogin.errors.email;
		}
		return buttonDisable || loading || !formikLogin.values.password || !!formikLogin.errors.password;
	};

	const getButtonText = () => {
		// return verifyEmailScreen ? "Verify Email" : "Sign in";
		return "Sign in";
	};

	const handleChangeEmail = () => {
		formikLogin.setFieldValue("password", "");
		formikLogin.setFieldValue("email", "");
		setVerifyEmailScreen(true);
		// setRememberMe(false);
		setIsEmailVerified(false);
		setEmail("");

		localStorage.removeItem("rememberedEmail");
		localStorage.removeItem("rememberExpiry");
	};

	const handleRememberMeChange = (e) => {
		const checked = e.target.checked;
		// setRememberMe(checked);

		if (!checked) {
			localStorage.removeItem("rememberedEmail");
			localStorage.removeItem("rememberExpiry");
		}
	};

	// if (verifyEmailScreen) {
	// 	return (
	// 		<>
	// 			<div className="fv-row mb-6 fv-plugins-icon-container mt-2">
	// 				<TextField
	// 					type="text"
	// 					placeholder="Enter your email address"
	// 					name="email"
	// 					autoComplete="off"
	// 					className="form-control fs-5 bg-transparent"
	// 					value={formikLogin.values.email}
	// 					onChange={(e) => formikLogin.setFieldValue("email", cleanEmail(e.target.value))}
	// 					onPaste={(e) => {
	// 						e.preventDefault();
	// 						formikLogin.setFieldValue("email", cleanEmail(e.clipboardData.getData("text")));
	// 					}}
	// 					onBlur={formikLogin.handleBlur}
	// 					error={formikLogin.touched.email && Boolean(formikLogin.errors.email)}
	// 					helperText={formikLogin.touched.email && formikLogin.errors.email}
	// 				/>
	// 			</div>

	// 			<div className="d-grid">
	// 				<button
	// 					onClick={formikLogin.handleSubmit}
	// 					className="btn btn-primary fs-3 h-50px d-flex align-items-center justify-content-center"
	// 					disabled={getButtonDisabled()}
	// 				>
	// 					{getButtonText()}
	// 					{loading && <LoadingSpinner />}
	// 				</button>
	// 			</div>
	// 		</>
	// 	);
	// }

	return (
		<>
			<div className="fv-row mb-6 fv-plugins-icon-container">
				<TextField
					type="text"
					placeholder="Enter your email address"
					name="email"
					autoComplete="off"
					className="form-control fs-5 bg-transparent"
					value={formikLogin.values.email}
					// disabled={true}
					onChange={formikLogin.handleChange}
					onBlur={formikLogin.handleBlur}
					error={formikLogin.touched.email && Boolean(formikLogin.errors.email)}
					helperText={formikLogin.touched.email && formikLogin.errors.email}
				/>
			</div>

			<div className="fv-row mb-3 fv-plugins-icon-container">
				<TextField
					type={showLoginPassword ? "text" : "password"}
					placeholder="Enter your password"
					name="password"
					autoComplete="off"
					className="form-control fs-5 bg-transparent"
					value={formikLogin.values.password}
					onChange={formikLogin.handleChange}
					onBlur={formikLogin.handleBlur}
					error={formikLogin.touched.password && Boolean(formikLogin.errors.password)}
					helperText={formikLogin.touched.password && formikLogin.errors.password}
					InputProps={{
						endAdornment: (
							<InputAdornment position="end">
								<IconButton onClick={toggleLoginPasswordVisibility} edge="end">
									{showLoginPassword ? <MyVisibilityOffIcon /> : <MyVisibilityIcon />}
								</IconButton>
							</InputAdornment>
						),
					}}
				/>
			</div>

			<div className="d-flex justify-content-between align-items-center my-6">
				{/* <div className="form-check mb-0">
					<input
						className="form-check-input border-primary cursor-pointer"
						type="checkbox"
						id="rememberMe"
						checked={rememberMe}
						onChange={handleRememberMeChange}
					/>
					<label className="form-check-label fs-6 mb-0 " htmlFor="rememberMe">
						Remember me
					</label>
				</div> */}

				<span
					className="fs-6 text-primary fw-bold cursor-pointer hover-underline"
					onClick={() => setCurrentScreen(SCREENS.FORGOT_PASSWORD)}
				>
					Forgot Password?
				</span>
			</div>

			<div className="d-grid">
				<button
					onClick={formikLogin.handleSubmit}
					className="btn btn-primary fs-3 h-50px d-flex align-items-center justify-content-center"
					disabled={getButtonDisabled()}
				>
					{getButtonText()}
					{loading && <LoadingSpinner />}
				</button>
			</div>

			<div className="separator separator-content mt-7 mb-4">
				<span className="w-100px text-muted fw-semibold fs-7" />
			</div>

			<div className="text-center mb-n4">
				<span className="text-muted fs-6">
					Want to change email?{" "}
					<span
						className="fw-bold fs-6 text-primary cursor-pointer link-hover hover-underline"
						onClick={handleChangeEmail}
					>
						Click here
					</span>
				</span>
			</div>
		</>
	);
};

export default Login;